import React, { useLayoutEffect } from 'react';
import { useAuth, useAuthCache } from '../hook/use-auth';

interface BaseProviderProps {
	children?: React.ReactNode;
	endpoint?: string;
	headers?: any;
}

const BaseProvider: React.FC<BaseProviderProps> = ({ children, endpoint, headers }) => {
	const { setAuthData } = useAuth();
	const [, setAuthCache] = useAuthCache();

	useLayoutEffect(() => {
		if (!window._Ajax) return;
		const _MyAjax = window._Ajax;

		class _Ajax2 extends _MyAjax {
			constructor(...props: any) {
				super(...props);

				this.options = {
					...this.options,
					// _Ajax 會把 url 前面的 / 拿掉
					url: this.options.url.test(/^http/) ? this.options.url : (endpoint || '') + '/' + this.options.url,
					headers: {
						...this.options.headers,
						...props[0]?.headers,
					},
				};
				this.headers = {
					...this.headers,
					...headers,
				};
			}

			onFailure() {
				if (this.xhr.status === 0) {
					setAuthData?.({ isLogin: false });
					setAuthCache?.(null);
					Utils.notice(document.getElementById('root'), '網路或服務端錯誤', 'error');
					super.onFailure();
					return;
				}
				if (this.xhr.status === 401) {
					setAuthData?.({ isLogin: false });
					setAuthCache?.(null);
					Utils.notice(document.getElementById('root'), '無效的token', 'error');
					return;
				}
				super.onFailure();
			}
		}

		window._Ajax = _Ajax2;
		window.APP = window.H2 = {
			_dom: {
				body: document.getElementById('root'),
			},
		};
	}, [endpoint, headers, setAuthCache, setAuthData]);

	return <>{children}</>;
};

export { BaseProvider };
export type { BaseProviderProps };
